// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PartialRecord<S, T> = {
  [K in keyof S]?: T;
};
